<template>
  <v-card flat>
    <v-toolbar color="green lighten-1" dark extended flat></v-toolbar>
    <v-layout row pb-2>
      <v-flex v-if="playlist" xs8 offset-xs2>
        <v-card class="card--flex-toolbar">
          <v-toolbar card prominent>
            <v-toolbar-title class="body-2">
              {{ playlist.name }}
            </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-btn @click="giveup" icon> <v-icon>help</v-icon> </v-btn>
            <v-btn @click="next" icon> <v-icon>skip_next</v-icon> </v-btn>
          </v-toolbar>

          <v-divider></v-divider>
          <v-card-text>
            <form @submit="guess">
              <v-text-field
                hide-details
                label="Guess"
                v-model="guessValue"
              ></v-text-field>
            </form>
          </v-card-text>
          <v-card-text v-if="correct">
            <v-card>
              <v-layout>
                <v-flex xs5>
                  <v-img
                    :src="currentTrack.album.images[0].url"
                    height="125px"
                    contain
                  ></v-img>
                </v-flex>
                <v-flex xs7>
                  <v-card-title primary-title>
                    <div>
                      <div class="headline">{{ currentTrack.name }}</div>
                      <div>{{ currentTrack.artists[0].name }}</div>
                      <div>
                        ({{ currentTrack.album.release_date.split("-")[0] }})
                      </div>
                    </div>
                  </v-card-title>
                </v-flex>
              </v-layout>
              <v-divider light></v-divider>
              <v-card-actions class="pa-3">
                Rate this album
                <v-spacer></v-spacer>
                <v-icon>star_border</v-icon>
                <v-icon>star_border</v-icon>
                <v-icon>star_border</v-icon>
                <v-icon>star_border</v-icon>
                <v-icon>star_border</v-icon>
              </v-card-actions>
            </v-card>
          </v-card-text>
          <v-card-text>
            <!-- <audio
              id="player"
              autoplay
              loop
              ref="player"
              v-on:ended="ended"
              :src="currentTrack.preview_url"
            ></audio>-->
            <vuetify-audio
              :file="currentTrack.preview_url"
              :autoPlay="true"
              :ended="giveup"
            ></vuetify-audio>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import VuetifyAudio from "vuetify-audio";

export default {
  components: {
    "vuetify-audio": VuetifyAudio
  },
  data() {
    return {
      guessValue: "",
      correct: false
    };
  },
  mounted() {
    const { id } = this.$route.params;

    this.$store.dispatch("getPlaylist", id);
  },
  methods: {
    guess: function(e) {
      const { guessValue } = this;

      e.preventDefault();
      this.$store
        .dispatch("guess", {
          val: this.currentTrack.name,
          guess: guessValue
        })
        .then(val => {
          if (val) {
            this.correct = true;
          }
        });
    },
    giveup: function() {
      this.correct = true;
    },
    next: function() {
      this.$store.dispatch("nextTrack");
      this.correct = false;
      this.guessValue = "";
    }
  },
  computed: {
    playlist() {
      return this.$store.getters.playlist;
    },
    currentTrack() {
      return this.$store.getters.currentTrack;
    }
  }
};
</script>
<style>
.card--flex-toolbar {
  margin-top: -64px;
}
</style>
